import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api.ts';

/** Client errors (4xx) are final; network and server errors are retried twice. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        refetchOnWindowFocus: false,
        // Past periods do not change; current ones override this per query.
        staleTime: 10 * 60_000,
      },
    },
  });
}
